import React from 'react';
import { fmtUsd, fmtPctOf } from './format';

export interface DeployableSegment {
  key: string;
  label: string;
  usd: number;
  className: string;
}

interface Props {
  navUsd: number;
  deployableUsd: number;
  segments: DeployableSegment[];
  cashReserveUsd: number;
}

const DeployableCapitalBar: React.FC<Props> = ({
  navUsd,
  deployableUsd,
  segments,
  cashReserveUsd,
}) => {
  const total = Math.max(navUsd, deployableUsd + cashReserveUsd, 1);

  return (
    <div className="space-y-2">
      <div className="flex h-3 w-full overflow-hidden rounded-full bg-gray-100">
        {segments.map((s) => (
          <div
            key={s.key}
            className={`h-full ${s.className}`}
            style={{ width: `${(s.usd / total) * 100}%` }}
            title={`${s.label}: ${fmtUsd(s.usd)}`}
          />
        ))}
        {cashReserveUsd > 0 ? (
          <div
            className="h-full bg-gray-200"
            style={{ width: `${(cashReserveUsd / total) * 100}%` }}
            title={`Cash reserve: ${fmtUsd(cashReserveUsd)}`}
          />
        ) : null}
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-600">
        {segments.map((s) => (
          <span key={s.key} className="inline-flex items-center gap-1.5">
            <span className={`inline-block h-2 w-2 rounded-full ${s.className}`} />
            {s.label} {fmtUsd(s.usd)} ({fmtPctOf(s.usd, deployableUsd)} deployable)
          </span>
        ))}
        {cashReserveUsd > 0 ? (
          <span className="inline-flex items-center gap-1.5">
            <span className="inline-block h-2 w-2 rounded-full bg-gray-200" />
            Cash reserve {fmtUsd(cashReserveUsd)}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default DeployableCapitalBar;
